var variables = require(process.env.themeFolder);

// missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
Object.keys(variables).forEach(function(key) {
    var value = parseInt(variables[key].toString().replace(/^\s+|\s+$/g,'').replace('px', ''));
    variables[key] = (isNaN(value)) ? variables[key] : value;
});

requirejs([
    'jquery',
],
function($) {
    if ($('body').hasClass('catalog-product-view')) {
        let button = '#product-addtocart-button';
        if ($('#out-of-stock-modal-button').length) {
            button = '#out-of-stock-modal-button';
        }

        $('.sticky-product-bar').on('click', 'button', function(e) {
            $(button).trigger(e);
            $(button + ' span').text($(button + ' span').text());
        });

        if ($(button).length && $('body').hasClass('catalog-product-view')) {
            $(function() {
                $(window).scroll(function() {
                    var scroll = $(window).scrollTop();
                    var cartBtnOffset = $(button).offset().top -50;
                    var cartBtnHeight = $(button).height();

                    if ($(window).width() < [variables.sm]) {
                        var cartBtnOffset = $(button).offset().top -62;
                    }

                    $('.sticky-product-bar').toggleClass('show', (scroll > cartBtnOffset + cartBtnHeight));
                    $('body').toggleClass('hide', (scroll > cartBtnOffset + cartBtnHeight));
                });
            });
        }
    }
});
